import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as contactscreen from './contactscreen.reducer';

export const selectContactscreenState =
  createFeatureSelector<contactscreen.IContactScreen>('contactScreen');

export const getFlagLoadScript = createSelector(
  selectContactscreenState,
  (state: contactscreen.IContactScreen) => {
    return state.flagLoadScript;
  },
);
export const getShowError = createSelector(
  selectContactscreenState,
  (state: contactscreen.IContactScreen) => {
    return state.showError;
  },
);

export const getGoBack = createSelector(
  selectContactscreenState,
  (state: contactscreen.IContactScreen) => {
    return state.goBack;
  },
);

export const getToken = createSelector(
  selectContactscreenState,
  (state: contactscreen.IContactScreen) => {
    return state.token;
  },
);

export const getDeeplink = createSelector(
  selectContactscreenState,
  (state: contactscreen.IContactScreen) => {
    return state.deeplink;
  },
);

export const getCustomerId = createSelector(
  selectContactscreenState,
  (state: contactscreen.IContactScreen) => {
    return state.customerId;
  },
);

export const getCustomerBirthDate = createSelector(
  selectContactscreenState,
  (state: contactscreen.IContactScreen) => {
    return state.customerBirthDate;
  },
);

export const getVersionApp = createSelector(
  selectContactscreenState,
  (state: contactscreen.IContactScreen) => {
    return state.versionApp;
  },
);

export const getOperatingSystem = createSelector(
  selectContactscreenState,
  (state: contactscreen.IContactScreen) => {
    return state.operatingSystem;
  },
);

export const getOptions = createSelector(
  selectContactscreenState,
  (state: contactscreen.IContactScreen) => {
    return state.menu;
  },
);

export const getGlobalId = createSelector(
  selectContactscreenState,
  (state: contactscreen.IContactScreen) => {
    return state.globalId;
  },
);

export const getCdaJourney = createSelector(
  selectContactscreenState,
  (state: contactscreen.IContactScreen) => {
    return state.cdaJourney;
  },
);
